<template>
  <span>
    <template>
      <v-navigation-drawer
        app
        v-model="drawer"
        class="primary lighten-2"
        dark
        disable-resize-watcher
      >
        <v-list>
          <v-list-tile v-for="item in items" :key="item.title" :to="item.to">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
    </template>
    <!-- <v-toolbar app class="primary text-xs-center" dark dense> -->
    <v-toolbar app class="primary text-xs-center" dark>
      <v-toolbar-side-icon class="hidden-md-and-up" @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-layout justify-center align-center>
        <v-spacer class="hidden-md-and-up"></v-spacer>
        <router-link to="/china">
          <v-btn flat class="hidden-sm-and-down">China
            <br>婚礼花絮
          </v-btn>
        </router-link>
        <router-link to="/schedule">
          <v-btn flat class="hidden-sm-and-down">Schedule
            <br>行程
          </v-btn>
        </router-link>
        <router-link to="/travel">
          <v-btn flat class="hidden-sm-and-down">Travel
            <br>指引
          </v-btn>
        </router-link>
        <router-link to="/photos">
          <v-btn flat class="hidden-sm-and-down">Photos
            <br>照片
          </v-btn>
        </router-link>
        <router-link to="/">
          <v-toolbar-title to="/">Dan & Anan
            <br>Wedding
          </v-toolbar-title>
        </router-link>
        <router-link to="/rsvp">
          <v-btn flat class="hidden-sm-and-down">RSVP
            <br>敬请回复
          </v-btn>
        </router-link>
        <router-link to="/faq">
          <v-btn flat class="hidden-sm-and-down">FAQ
            <br>常见问题
          </v-btn>
        </router-link>
        <router-link to="/registry">
          <v-btn flat class="hidden-sm-and-down">Reigistry
            <br>礼品链接
          </v-btn>
        </router-link>
        <router-link to="/contact">
          <v-btn flat class="hidden-sm-and-down">Contact
            <br>联系方式
          </v-btn>
        </router-link>
      </v-layout>
    </v-toolbar>
  </span>
</template>

<script>
export default {
  name: 'AppNavigation',
  data() {
    return {
      appTitle: 'Dan & Anan Wedding',
      drawer: false,
      items: [
        { title: 'Home 主页', icon: 'home', to: '/' },
        { title: 'RSVP 敬请回复', icon: 'reply', to: '/rsvp' },
        { title: 'Schedule 行程', icon: 'event', to: '/schedule' },
        { title: 'Travel 指引', icon: 'map', to: '/travel' },
        { title: 'Photos 照片', icon: 'photo_camera', to: '/photos' },
        { title: 'FAQ 常见问题', icon: 'fa fa-question-circle', to: '/faq' },
        { title: 'Registry 礼品链接', icon: 'view_list', to: '/registry' },
        { title: 'Contact 联系方式', icon: 'email', to: '/contact' },
        { title: 'China 婚礼花絮', icon: 'flight_takeoff', to: '/china' },
      ],
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
};
</script>

<style scoped>
a {
  color: white;
  text-decoration: none;
}
</style>
